// Generated by merge-translation-files.mjs -- do not edit by hand.
// Content-hashed name, so a translation change busts the long-lived cache on this file.
export default 'translations.49aeebf8.json';
